// extracted by css-extract-rspack-plugin
export default {"cls1":"utils-cls1_Wf6","cls2":"utils-cls2_Odi utils-cls1_Wf6"};